import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { DARK_DIALOG, DARK_INPUT } from "../control/shared";
import { CAT } from "./util";

export function ReasonDialog({ label, title, danger, testid, onSubmit }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => { setBusy(true); try { await onSubmit(reason.trim()); setOpen(false); setReason(""); } catch { /* toast shown */ } finally { setBusy(false); } };
  return (
    <>
      <Button size="sm" variant="outline" className={`bg-transparent ${danger ? "border-red-500/50 text-red-300" : "border-slate-700 text-slate-200"}`} onClick={() => setOpen(true)} data-testid={testid}>{label}</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className={`${DARK_DIALOG} max-w-md`} data-testid={`${testid}-dialog`}>
          <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
          <Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (required)" className={DARK_INPUT} data-testid={`${testid}-reason`}/>
          <div className="flex justify-end"><Button className={danger ? "bg-red-600 hover:bg-red-700" : "bg-orange-500 hover:bg-orange-600"} disabled={reason.trim().length < 5 || busy} onClick={go} data-testid={`${testid}-confirm`}>Confirm</Button></div>
        </DialogContent>
      </Dialog>
    </>
  );
}

const FIELDS = [["name", "Full name"], ["father_name", "Father's name"], ["date_of_birth", "Date of birth", "date"], ["address", "Address"], ["city", "City"],
  ["district", "District"], ["state", "State"], ["pincode", "PIN code"], ["emergency_contact", "Emergency contact"], ["experience_years", "Experience (years)", "number"]];

export function EditDialog({ user, onSave }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({});
  const start = () => { setF(Object.fromEntries([...FIELDS.map(([k]) => [k, user[k] ?? ""]), ["categories", user.categories || []], ["public_photo_consent", !!user.public_photo_consent]])); setOpen(true); };
  const save = async () => {
    const changes = Object.fromEntries(Object.entries(f).filter(([k, v]) => JSON.stringify(v) !== JSON.stringify(user[k] ?? (k === "categories" ? [] : k === "public_photo_consent" ? false : ""))));
    if (changes.experience_years !== undefined) changes.experience_years = +changes.experience_years;
    if (!Object.keys(changes).length) { setOpen(false); return; }
    try { await onSave(changes); setOpen(false); } catch { /* toast shown */ }
  };
  const tog = (c) => setF((x) => ({ ...x, categories: x.categories.includes(c) ? x.categories.filter((y) => y !== c) : [...x.categories, c] }));
  return (
    <>
      <Button size="sm" variant="outline" className="border-slate-700 bg-transparent text-slate-200" onClick={start} data-testid="wd-edit">Edit details</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className={`${DARK_DIALOG} max-w-lg max-h-[85vh] overflow-y-auto`} data-testid="wd-edit-dialog">
          <DialogHeader><DialogTitle>Edit worker details</DialogTitle></DialogHeader>
          <div className="grid sm:grid-cols-2 gap-3">
            {FIELDS.map(([k, l, t]) => (
              <label key={k} className={k === "address" ? "sm:col-span-2" : ""}><span className="text-xs text-slate-400">{l}</span>
                <Input type={t || "text"} value={f[k] ?? ""} onChange={(e) => setF((x) => ({ ...x, [k]: e.target.value }))} className={`${DARK_INPUT} mt-1`} data-testid={`wd-edit-${k}`}/></label>
            ))}
          </div>
          <div className="grid grid-cols-2 gap-2">{Object.entries(CAT).map(([k, l]) => (
            <label key={k} className="flex items-center gap-2 text-sm"><Checkbox checked={(f.categories || []).includes(k)} onCheckedChange={() => tog(k)} data-testid={`wd-edit-cat-${k}`}/>{l}</label>))}</div>
          <label className="flex items-center gap-2 text-sm"><Checkbox checked={!!f.public_photo_consent} onCheckedChange={(v) => setF((x) => ({ ...x, public_photo_consent: !!v }))}/>Show photo on public verification page</label>
          <p className="text-xs text-slate-500">Every change is saved to the worker's audit history.</p>
          <div className="flex justify-end"><Button className="bg-orange-500 hover:bg-orange-600" onClick={save} data-testid="wd-edit-save">Save changes</Button></div>
        </DialogContent>
      </Dialog>
    </>
  );
}
